// extracted by mini-css-extract-plugin
export default {"container":"spinner_container__lNxfC"};